import getModelsURL from "./getModelsURL";
import getBoothsData from "./getBoothsData";
import calculateBoothPositions from "./calculateBoothPositions";
import { ROOMS_DATA } from "../configs/ROOMS_DATA";
import { SCENE_DATA } from "../configs/SCENE_DATA";
import { IBooth } from "../store/interfaces/IBooth";
import { IRoomsData } from "../configs/interfaces/IRoomsData";
import { DocumentData } from "firebase/firestore";
import { EXPANDED_STRIPE_WIDTH } from "../configs/STRIPES_ANIMATION_CONFIG";
import { calculateBoothRotations } from "./calculateBoothRotations";
import { HALLS } from "../configs/HALLS_CONFIG";

const firebaseBoothsDataPromise = getBoothsData();
const firestorageBoothModelPromise = getModelsURL("Large.glb");
const firestorageBoothSmallModelPromise = getModelsURL("Small.glb");
const firestorageWarehouseModelPromise = getModelsURL("Final.glb");

const sortBoothsByNameID = (halls: any) => {
  const sortedHalls = halls;
  Object.values(HALLS).forEach(() => {
    sortedHalls.sort(
      (
        { description: description1 }: { description: any },
        { description: description2 }: { description: any }
      ) => {
        if (description1[1] < description2[1]) {
          return -1;
        }
        if (description1[1] > description2[1]) {
          return 1;
        }
      }
    );
    sortedHalls.sort(
      (
        { description: description1 }: { description: any },
        { description: description2 }: { description: any }
      ) => {
        const splitBoothFromHall1 = description1.split("/")[1];
        const splitBoothFromHall2 = description2.split("/")[1];
        if (splitBoothFromHall1 < splitBoothFromHall2) {
          return -1;
        }
        if (splitBoothFromHall1 > splitBoothFromHall2) {
          return 1;
        }
      }
    );
  });
  return sortedHalls;
};

const populateRooms = (booths: IBooth[]) => {
  if (booths.length === 0 || booths === undefined || booths === null) return;
  const boothPositions = calculateBoothPositions();
  if (!boothPositions) return;
  const boothRotations = calculateBoothRotations();
  if (!boothRotations) return;
  const sortedBooths = sortBoothsByNameID(booths);
  for (const singleHall in ROOMS_DATA) {
    let positionIndex = 0;
    sortedBooths.forEach(
      ({
        description,
        standName,
        ...rest
      }: {
        description: any;
        standName: any;
        rest: any;
      }) => {
        const splitDescription = description.split("/");
        const hallID = splitDescription[0];
        if (hallID === singleHall) {
          const boothID = splitDescription[1];
          ROOMS_DATA[singleHall as keyof IRoomsData].push({
            id: standName,
            name: `${hallID}-${boothID}`,
            position: boothPositions[positionIndex],
            rotation: boothRotations[positionIndex],
            standName: standName,
            standSize:
              positionIndex === 0 || positionIndex === 6 || positionIndex === 10
                ? "large"
                : "small",
            data: rest,
          });
          positionIndex++;
        }
      }
    );
  }
};

export const initializeScene = () => {
  return Promise.all([
    firebaseBoothsDataPromise,
    firestorageBoothModelPromise,
    firestorageWarehouseModelPromise,
    firestorageBoothSmallModelPromise,
  ])
    .then((res) => {
      populateRooms((res[0] as DocumentData[])[0].stands);
      SCENE_DATA.boothURL = res[1] as string;
      SCENE_DATA.warehouseURL = res[2] as string;
      SCENE_DATA.boothSmallURL = res[3] as string;
      return SCENE_DATA;
    })
    .catch((err) => err);
};

export const initializeStripesFirstRender = () => {
  const stripe1: any = document.querySelector(".stripe-1");
  const stripe2: any = document.querySelector(".stripe-2");
  const stripe3: any = document.querySelector(".stripe-3");
  const stripe4: any = document.querySelector(".stripe-4");
  if (!stripe1 || !stripe2 || !stripe3 || !stripe4) return;
  stripe1.style.width = EXPANDED_STRIPE_WIDTH;
  stripe2.style.width = EXPANDED_STRIPE_WIDTH;
  stripe3.style.width = EXPANDED_STRIPE_WIDTH;
  stripe4.style.width = EXPANDED_STRIPE_WIDTH;
};
